define(["highcharts.core", "highcharts.more"], function (Highcharts) {
    "use strict";

    return Highcharts;
});
